import { useMemo } from "react";

import { useFeatureFlags } from "@hooks/http";

export const useIsAllowedToSeeCustomerDetails = () => {
  const { hasFeatureFlag } = useFeatureFlags();

  return useMemo(() => {
    const hasWhiteListingFlag = hasFeatureFlag("forceWhiteListing");
    const hasCustomerDetailsWhiteListFlag = hasFeatureFlag(
      "customerDetailsWhitelistFlag",
    );

    if (!hasWhiteListingFlag) {
      return true;
    }

    return hasCustomerDetailsWhiteListFlag;
  }, [hasFeatureFlag]);
};
